import {_} from "vue-underscore";
import api from "../utils/api.js";
import events from "../utils/events.js";
import { trackEvent } from '../utils/tracking';
import { OUTFIT_TYPES } from "../../config.js";

export const generatedOutfits = {
    namespaced: true,
    state: {
        noOutfitsForTheseFilters: false,
        currentOutfit: {},
        generatedOutfits: [],
        undoOutfit: null,
        outfitsLoading: false,
        gaeVersion: null,
    },
    getters: {
        generatedOutfitCurrent(state) {
            return state.currentOutfit;
        },
        getNoOutfits(state){
            return state.noOutfitsForTheseFilters;
        },
        undoOutfit(state){
            return state.undoOutfit;
        },
        gaeVersion(state) {
            return state.gaeVersion;
        },
    },
    mutations: {
        setGaeVersion(state, gaeVersion) {
            state.gaeVersion = gaeVersion;
        },
        getNextOutfit(state) {
            state.currentOutfit = state.generatedOutfits.shift() || {};

            /* Map selected to all outfit products */
            if(state.currentOutfit.products) {
                _.each(state.currentOutfit.products, product => {
                    product.selected = true;
                });
            }
        },
        removeProductFromOutfitCurrent(state, payload) {
            let product = payload.product;
            let index = state.currentOutfit.products.indexOf(product);
            if (index !== -1) state.currentOutfit.products.splice(index, 1);
            this.dispatch('generatedOutfits/updateCurrentOutfit', state.currentOutfit.products);
        },
        selectOutfitProduct(state, payload) {
            var product = payload.product;
            var index = state.currentOutfit.products.indexOf(product);
        },
        setOutfitProductsSelected(state, payload) {
            _.each(state.currentOutfit.products, product => {
                console.log('set product selected');
                product.selected = payload.ids ? payload.ids.includes(product.product_id) : true;
            });
        },
        resetGeneratedOutfits(state) {
            state.generatedOutfits = [];
        },
        resetNoOutfitsForTheseFilters(state) {
            state.noOutfitsForTheseFilters = false;
        },
        addGeneratedOutfits(state, payload) {
            const newOutfits = events
                .filterInteractedOutfits(payload.response.outfits)
                .filter((outfit) => {
                    return (
                        outfit.outfit_id !== state.currentOutfit.outfit_id &&
                        state.generatedOutfits.every(
                            (generatedOutfit) =>
                                generatedOutfit.outfit_id !== outfit.outfit_id
                        )
                    );
                });

            if (newOutfits.length) {
                state.noOutfitsForTheseFilters = false;
                state.generatedOutfits.push(
                    ...newOutfits.map(outfit => ({
                        ...outfit,
                        currentProductIndex: 0,
                        type: OUTFIT_TYPES.GENERATED,
                    }))
                );
            } else if(!state.currentOutfit.products) {
                state.currentOutfit = {};
                state.noOutfitsForTheseFilters = true;
            }
        },
        setCurrentOutfit(state, outfit){
            const products = outfit.products.map((product) => {
                if(!state.currentOutfit.products) {
                    return {
                        ...product,
                        selected: true
                    };
                }                

                const currentProduct = state.currentOutfit.products.find(currentProduct => currentProduct.product_id === product.product_id) || {};

                return {
                    ...currentProduct,
                    ...product,
                };
            });

            state.currentOutfit = {
                ...outfit,
                products,
                type: OUTFIT_TYPES.GENERATED,
            }
        },
        setUndoOutfit(state, value){
            state.undoOutfit = value;
        },
        resetCurrentOutfit(state) {
            state.currentOutfit = {};
        },
        resetState(state){
            state.noOutfitsForTheseFilters = false;
            state.currentOutfit = {};
            state.generatedOutfits = [];
            state.undoOutfit = null;
        },
        resetCurrentOutfitFromUndo(state){
            state.generatedOutfits.unshift(state.currentOutfit);
            state.currentOutfit = state.undoOutfit;
            state.undoOutfit = null;
        },
        changeOutfitProduct(state, payload) {
            let index = payload.index;
            state.currentOutfit.products.splice(
                index,
                1,
                Object.assign({}, state.currentOutfit.products[index], {
                    ...payload.product
                })
            );
        },
        changeCurrentProduct(state, payload) {
            const { currentProductIndex } = payload;

            state.currentOutfit = {
                ...state.currentOutfit,
                currentProductIndex,
            };
        },
        setOutfitsLoading(state, status) {
            state.outfitsLoading = status;
        }
    },
    actions: {
        generateNewOutfits(context) {
            // Load filters from filter module
            const { optionValues: product_option_value_ids, pricePercentage: outfit_price_percentage, sort } = context.rootGetters['filters/selectedFilters'];

            context.commit('setOutfitsLoading', true);
            const latestLikes = events.getAndResetLatestLikedOutfits();
            const latestRejects = events.getAndResetLatestRejectedOutfits();

            const uri = api.outfitsUri();

            const params = {
                product_option_value_ids,
                outfit_price_percentage,
                latest_likes: latestLikes,
                latest_rejects: latestRejects,
                limit: 10,
                sort_field_type: sort.type,
                order: sort.order,
                gae_version: context.state.gaeVersion,
            }

            return api
                .get(uri, {
                    params
                })
                .then(response => {
                    context.commit("addGeneratedOutfits", {
                        response: response
                    });
                    if(!context.state.currentOutfit || !context.state.currentOutfit.products){
                        context.commit('getNextOutfit');
                    }
                    context.commit('setGaeVersion', response.gae_version);
                })
                .catch(error => {
                    trackEvent("recommended_outfits_error", {});
                })
                .finally(() => {
                    context.commit('setOutfitsLoading', false);
                });
        },
        updateCurrentOutfit(context, products) {
            let uri = api.outfitsUri()
            console.log("ctx: ", context);
            return api
                .post(uri,
                    {
                        products,
                        outfit_id_original: context.state.currentOutfit.original_outfit_id || context.state.currentOutfit.outfit_id
                    }
                )
                .then(response => {
                    const newProducts = response.body.outfit.products.map(product => {
                        const productFromState = products.find(productFromState => productFromState.product_id === product.product_id);

                        return {
                            ...product,
                            outfit_priority: productFromState.outfit_priority || product.outfit_priority,
                            outfit_priority_parent: productFromState.outfit_priority_parent || product.outfit_priority_parent,
                        };
                    });
                    context.commit('setCurrentOutfit', {
                        ...response.body.outfit,
                        products: newProducts,
                    });
                    _.each(context.state.currentOutfit.products, product => {
                        product.selected = true;
                    });
                    return 'Current Outfit Updated';
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                });
        },
        swapProductFromOutfitCurrent(context, payload) {
	        const { removeProduct, swapProduct } = payload;
            const { currentOutfit } = context.state;
            const productIndex = currentOutfit.products.findIndex(product => product.product_id == removeProduct.product_id);
	        const product = {
                ...removeProduct,
                ...swapProduct,
                outfit_priority: swapProduct.outfit_priority || removeProduct.outfit_priority,
                outfit_priority_parent: swapProduct.outfit_priority_parent || removeProduct.outfit_priority_parent
            };

	        if (productIndex !== -1) {
                events.trackEvent(
                    'swap_product',
                    {
                        outfitId: currentOutfit.outfit_id,
                        outfitAltered: true,
                        originalProductId: removeProduct.product_id,
                        swappedProductId: swapProduct.product_id,
                        isPersonalized: currentOutfit.outfit_featured,
                        outfitScore: currentOutfit.outfit_score,
                        gaeVersion: context.rootGetters['products/gaeVersion'],
                    }
                );
                trackEvent("swap_product", {content_id: removeProduct.product_id});

		        this.commit('generatedOutfits/changeOutfitProduct', {
                    index: productIndex,
                    product,
                });
		        this.dispatch('products/changeCurrentProduct', { product });
		        return this.dispatch('generatedOutfits/updateCurrentOutfit', currentOutfit.products);
	        } else {
		        return Promise.reject(new Error('error swapping product'));
	        }
        },
        fetchNewOutfits(context) {
            context.commit('resetState');
            return context.dispatch('generateNewOutfit');
        },
        generateNewOutfit(context, copyUndoOutfit) {
            const { state } = context;

            context.commit('setUndoOutfit', copyUndoOutfit ? state.currentOutfit : null);
            context.commit('getNextOutfit');
            
            if (state.generatedOutfits.length < 2 && !state.outfitsLoading) {
                context.dispatch("generateNewOutfits");
            }
        },
        resetGeneratedOutfits: {
            root: true,
            handler (namespacedContext, payload) {
                namespacedContext.commit('resetGeneratedOutfits')
            }
        },
        resetCurrentOutfit: {
            root: true,
            handler (namespacedContext, payload) {
                namespacedContext.commit('resetCurrentOutfit')
            }
        }
    }
};
